/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type { IdResponse, SuccessResponse, TenantDivisionListResponse } from './model';

export const getListTenantDivisionsResponseMock = (): TenantDivisionListResponse => ({
  count: 3,
  items: [
    {
      id: '00000001-0000-0000-0000-000000000001',
      code: 'D001',
      name: '総務課',
      year: 2025,
      created_at: '2024-01-01T00:00:00Z',
      updated_at: '2024-01-01T00:00:00Z',
    },
    {
      id: '00000002-0000-0000-0000-000000000002',
      code: 'D002',
      name: '企画課',
      year: 2025,
      created_at: '2024-01-01T00:00:00Z',
      updated_at: '2024-01-01T00:00:00Z',
    },
  ],
});

export const getCreateTenantDivisionResponseMock = (): IdResponse => ({
  id: '00000003-0000-0000-0000-000000000003',
});

export const getUpdateTenantDivisionResponseMock = (): SuccessResponse => ({ success: true });

export const getListTenantDivisionsMockHandler = (
  overrideResponse?:
    | TenantDivisionListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TenantDivisionListResponse> | TenantDivisionListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/tenants/divisions',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListTenantDivisionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateTenantDivisionMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/tenants/divisions',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateTenantDivisionResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateTenantDivisionMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/tenants/divisions/:divisionId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateTenantDivisionResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getListTenantDivisionsMockHandler(),
  getCreateTenantDivisionMockHandler(),
  getUpdateTenantDivisionMockHandler(),
];
